import { ComponentProps } from 'react';

export function GraduationCap({ ...props }: ComponentProps<'svg'>) {
  return (
    <svg
      {...props}
      width="40"
      height="28"
      viewBox="0 0 40 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.9437 6.55625L21.275 0.23125C20.8937 0.076875 20.45 0 20 0C19.55 0 19.1062 0.076875 18.675 0.23L1.00312 6.55625C0.402375 6.775 0 7.35 0 8C0 8.65 0.402375 9.22812 1.00312 9.44312L4.75437 10.7875C4.01125 11.775 3.48813 12.9225 3.22 14.1594C2.50312 14.4625 2 15.175 2 16C2 16.6221 2.30087 17.1556 2.74625 17.5225L1.19438 26.835C1.0925 27.4437 1.5625 28 2.18062 28H5.81938C6.43731 28 6.9075 27.4451 6.80562 26.8356L5.25375 17.5231C5.69937 17.1562 6 16.5688 6 16C6 15.3569 5.67662 14.8106 5.205 14.4444C5.47075 13.3344 6.01 12.3306 6.76375 11.505L18.6763 15.7694C19.1063 15.925 19.55 16 20 16C20.45 16 20.8969 15.9232 21.3256 15.7698L38.9944 9.44475C39.6 9.225 40 8.65 40 8C40 7.35 39.6 6.775 38.9437 6.55625ZM20.3188 12.9438C20.042 13.0428 19.8064 12.9864 19.6881 12.9441L10.9688 9.825L20.2938 6.955C20.8221 6.79287 21.1162 6.23313 20.9544 5.70375C20.7922 5.17638 20.2313 4.87437 19.7038 5.04437L7.825 8.7L5.8725 8L19.6287 3.055C19.9055 2.956 20.1411 3.01227 20.2594 3.05463L34.125 8L20.3188 12.9438ZM28.2687 15.4062L29 22.4188C29 23.0813 25.9062 25 20 25C14.0938 25 11 23.08 11 22.4163L11.7325 15.41L8.8525 14.3787L8.00813 22.26C8 26.0812 14.0375 28 20 28C25.9625 28 32 26.0819 31.9937 22.2619L31.1494 14.3806L28.2687 15.4062Z"
        fill="currentColor"
      />
    </svg>
  );
}
